import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRoutes } from './ApiRoutes';
import { Gt2ApiService } from './gt2-api.service';
import {
  OrganizationIdentityListResponse,
  OrganizationIdentityPayload,
  OrganizationIdentityResponse,
} from './models/OrganizationIdentityModel';

/**
 * CRUD service for OrganizationIdentity sub-resources.
 * Base route: /v1/organizationidentities
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationIdentitiesService {
  constructor(
    private http: HttpClient,
    private api: Gt2ApiService,
  ) {}

  public getAll(
    page: number = 1,
    limit: number = 100,
  ): Observable<OrganizationIdentityListResponse> {
    const url =
      this.api.createUrl(ApiRoutes.ORGANIZATION_IDENTITIES) +
      `?page=${page}&limit=${limit}`;
    return this.http.get<OrganizationIdentityListResponse>(url);
  }

  public getByUUID(uuid: string): Observable<OrganizationIdentityResponse> {
    return this.http.get<OrganizationIdentityResponse>(
      this.api.createUrl(ApiRoutes.ORGANIZATION_IDENTITIES) + '/' + uuid,
    );
  }

  public create(
    payload: OrganizationIdentityPayload,
  ): Observable<OrganizationIdentityResponse> {
    return this.http.post<OrganizationIdentityResponse>(
      this.api.createUrl(ApiRoutes.ORGANIZATION_IDENTITIES),
      payload,
    );
  }

  public update(
    uuid: string,
    payload: Partial<OrganizationIdentityPayload>,
  ): Observable<OrganizationIdentityResponse> {
    return this.http.patch<OrganizationIdentityResponse>(
      this.api.createUrl(ApiRoutes.ORGANIZATION_IDENTITIES) + '/' + uuid,
      payload,
    );
  }

  public delete(uuid: string): Observable<any> {
    return this.http.delete<any>(
      this.api.createUrl(ApiRoutes.ORGANIZATION_IDENTITIES) + '/' + uuid,
    );
  }
}
